export default __webpack_public_path__ + "static/media/logo-light.11cbf964.svg";